var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"online-bar"},[_c('div',{staticClass:"online-label"},[_vm._v(_vm._s(_vm.$t('offline.modals.back_online')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }